import { Box, Grid, Theme, Typography } from "@mui/material";
import { KeyValue } from "../../ApplicationDetails/personalDetails";
import React from "react";
import { SubHeading } from "../../investors/components";
import { applicantStatusMasters } from '../../../utils/constant';
import { ViewProfileProps } from "../types";
import { getUniqueIdentityText, isOnboardingTypeMinor } from "../../../utils/utilityFunctions";
import { formatShortDate } from "../../../utils/date";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";

export default function PersonalDetails({ overviewData }: { overviewData: any }): JSX.Element {
    const { applicants, modeOfHolding } = overviewData
    const { company = "WMS" } = useSelector((state: RootStateType) => state.navbarInfo)

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    bgcolor: 'white',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    borderRadius: '10px',
                    border: `1px solid ${theme.palette.grey[100]}`,
                    padding: '25px',
                    mb: '40px'

                })}
            >
                <Box>
                    <Grid container >
                        <Grid item xs={12} >
                            <Typography  variant="h2" sx={(theme: Theme) => ({ fontSize: 18, fontWeight: 700, color: theme.palette.primary[900], mb: '25px' })}>
                                Personal Details
                            </Typography>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant='body_500'
                                sx={{
                                    color: 'text.secondary',
                                }}>
                                Mode of Holding
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant='body_500'
                                sx={{
                                    color: 'text.primary',
                                    textTransform: 'capitalize',
                                }}>
                                {modeOfHolding || 'Single'}
                            </Typography>
                        </Grid>
                        {applicants?.map((applicant: any, index: number) => {
                            const title = [
                                'First Applicant Details',
                                'Second Applicant Details',
                                'Third Applicant Details',
                            ][index];
                            return (
                                <React.Fragment key={applicant.id}>
                                    <SubHeading
                                        sx={{
                                            letterSpacing: '0.02px',

                                        }}>
                                        {isOnboardingTypeMinor(overviewData?.onboardingType || '')
                                            ? 'Personal Details of Guardian'
                                            : title}
                                        {/* {title} */}
                                    </SubHeading>

                                    <Grid
                                        item
                                        container
                                        rowSpacing={3}
                                        columnSpacing={5.5}
                                        direction="row"

                                    >
                                        <KeyValue title={'First Name'} description={applicant.firstName} />
                                        <KeyValue title={'Last Name'} description={applicant.lastName} />
                                        <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={applicant.panNo} />
                                        <KeyValue title={'Date of Birth'} description={applicant?.dateOfBirth ? formatShortDate(applicant.dateOfBirth) : "-"} />
                                        <KeyValue title={'Marital Status'} description={applicant.maritalStatus} />
                                        <KeyValue title={'Gender'} description={applicant.gender} />
                                        <KeyValue
                                            title={'Occupation Type'}
                                            description={applicant.occupationDetails}
                                        />
                                        <KeyValue
                                            title={'Status'}
                                            description={
                                                applicant.status
                                                    ? applicantStatusMasters[applicant.status]
                                                    : applicant.status
                                            }
                                        />
                                        {index !== 0 && (
                                            <KeyValue
                                                title={'Relationship With First Applicant'}
                                                description={applicant.relationShipWithFirstApplicant}
                                            />
                                        )}
                                    </Grid>
                                    {isOnboardingTypeMinor(overviewData?.onboardingType || '') && (
                                        <>
                                            <SubHeading
                                                sx={{
                                                    color: 'common.black',
                                                    letterSpacing: 0.5 + 'px',
                                                    padding: { xs: '10px 10px', sm: '10px 30px' },
                                                }}>
                                                Personal Details of Minor Applicant
                                            </SubHeading>

                                            <Grid
                                                item
                                                container
                                                // pb={5}
                                                rowSpacing={3}
                                                columnSpacing={5.5}
                                                direction="row"
                                            // justifyContent="space-between"
                                            // alignItems="flex-start"
                                            >
                                                <KeyValue title={`${getUniqueIdentityText(company)?.pan}`} description={applicant.minorPan} />
                                                <KeyValue
                                                    title={'Date of Birth'}
                                                    description={formatShortDate(applicant.minorDOB)}
                                                />
                                                {/* <KeyValue title={'Full Name'} description={applicant.minorName} /> */}
                                                <KeyValue
                                                    title={'First Name'}
                                                    description={applicant.minorNamePrefix + ' ' + applicant.minorFirstName}
                                                />
                                                <KeyValue title={'Last Name'} description={applicant.minorLastName} />
                                                <KeyValue title={'Father Name'} description={applicant.minorFatherName} />
                                                <KeyValue title={'Gender'} description={applicant.minorGender} />
                                                <KeyValue title={'Email'} description={applicant.minorEmail} />
                                                <KeyValue title={'Mobile Number'} description={applicant.minorMobile} />
                                                <KeyValue
                                                    title={'Relationship with Guardian'}
                                                    description={applicant.guardianRelationship}
                                                />
                                            </Grid>
                                        </>
                                    )}

                                </React.Fragment>
                            );
                        })}
                    </Grid>
                </Box>
            </Box >
        </>
    )
}